import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

type SentryInitOptions = {
	app: App
	dsn?: string | null
	release: string
	router?: Router
	replay?: boolean
	tracesSampleRate?: number
}

const dataCollection = {
	userInfo: false,
	cookies: false,
	httpHeaders: {
		request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
		response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
	},
	httpBodies: [],
	urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
	genAI: { inputs: false, outputs: false },
	databaseQueryData: false,
	graphQL: { document: false, variables: false },
	frameContextLines: 7,
}

export function sentryInit({ app, dsn, release, router, replay, tracesSampleRate }: SentryInitOptions): void
{
	if (!dsn) return

	Sentry.init({
		app,
		dsn,
		dataCollection,
		integrations: [
			...(router ? [Sentry.browserTracingIntegration({ router })] : []),
			...(replay ? [Sentry.replayIntegration()] : []),
		],
		release,
		allowUrls: [window.location.origin],
		...(tracesSampleRate === undefined ? {} : { tracesSampleRate }),
	})
}